import React from "react";
import MpTextFieldMultiple from "../../../../components/MpTextFieldMultiple";
import { useTranslation } from "src/hooks";

interface IProps {
  value: string;
  onChange: (event: any) => void;
  label: string;
  count?: number;
}

const WalletAddressMultipleTextField = (props: IProps) => {
  const { value, onChange, label, count } = props;

  const { t } = useTranslation("tronWalletResourceBalance");

  return (
    <>
      <MpTextFieldMultiple
        value={value}
        onChange={onChange}
        label={label || t("phWallet_address")}
        count={count || value ? value.split(",").length : 0}
      />
    </>
  );
};

export default WalletAddressMultipleTextField;
